import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';

// routes with no `data.menu` (or one not backed by a real permission, e.g. a
// dashboard fallback) are treated as open to any authenticated admin
const SUPERADMIN_ONLY_MENUS = ['administrator', 'role'];

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(
    public authService: AuthenticationService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.authService.isAuthenticated.pipe(
      take(1),
      map(isAuthenticated => {
        if(!isAuthenticated) {
          this.router.navigateByUrl('/login', { replaceUrl: true });
          return false;
        }
        const menu = route.data && route.data.menu;
        if(!menu){ return true; } // no menu tag — nothing to gate (e.g. the wildcard fallback)
        if(SUPERADMIN_ONLY_MENUS.includes(menu) && !this.authService.isSuperAdmin()){
          this.router.navigateByUrl('/dashboard', { replaceUrl: true });
          return false;
        }
        if(!this.authService.hasMenu(menu)) {
          const landing = this.authService.landingRoute();
          if(landing && landing !== this.router.url){
            this.router.navigateByUrl(landing, { replaceUrl: true });
          }else{
            // no accessible menu at all — the account has no usable role
            this.authService.logout();
            this.router.navigateByUrl('/login', { replaceUrl: true });
          }
          return false;
        }
        return true;
      })
    )
  }

}
